import React, { useEffect } from "react";
import Card from "components/card";
import { useDispatch, useSelector } from "react-redux";
import { getAdminDetailsByIdThunk } from "slices/userSlice";
import { useParams } from "react-router-dom";
const AdminDetailsPage = () => {
    const {id}=useParams()
     const dispatch=useDispatch();
 const {
  name = '',
  email = '',
  role = '',
  appID = '',
  createdAt = '',
  updatedAt = '',
  isDeleted = false,
  _id = '',
} = useSelector(
  (state) => state?.users?.adminDetails?.data || {}
);
     useEffect(()=>{
dispatch(getAdminDetailsByIdThunk(id))
     },[id])
  return (
    <div>
      {email && <Card extra="mt-3 !z-5 overflow-hidden">
        <div className="flex items-center justify-between rounded-t-3xl p-3">
          <h3 className="text-lg font-bold text-navy-700 dark:text-white">
            Admin Profile & Activity
          </h3>
      
        </div>
      
        {email ? (
          <>
          <div className="flex-col items-start space-x-4 bg-white p-4 hover:shadow-lg dark:bg-navy-800 dark:hover:bg-navy-700">
          <div className="flex items-start space-x-4 bg-white p-4 ">
            <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-gray-100 overflow-hidden">
            
            </div>
      
         <div className="pt-16 pb-6 px-6">
              <h4 className="text-xl font-semibold text-gray-900 dark:text-white truncate">
                {name || "N/A"} ({appID || '####'})
              </h4>
              <p className="text-sm text-gray-600 dark:text-gray-400 truncate">
                {email || "N/A"}
              </p>
      
              <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-gray-600 dark:text-gray-400">
                <div><span className="font-medium dark:text-gray-200">User ID:</span> {_id}</div>
                <div><span className="font-medium dark:text-gray-200">Role:</span> {role}</div>
                <div><span className="font-medium dark:text-gray-200">App Id:</span> {appID}</div>
                <div><span className="font-medium dark:text-gray-200">Status:</span> {isDeleted ? "InActive" :"Active"}</div>
                <div><span className="font-medium dark:text-gray-200">Created Date:</span> {createdAt ? new Date(createdAt).toLocaleDateString() : 'N/A'}</div>
                <div><span className="font-medium dark:text-gray-200">Last Update:</span> {updatedAt ? new Date(updatedAt).toLocaleDateString() :"N/A"}</div>
  
              </div>
      
             
            </div>
      </div>
      
            </div>
            </>) :
          <div className="flex items-center justify-center h-48 bg-gray-100 dark:bg-navy-800 rounded-lg">
            <p className="text-gray-500 dark:text-gray-400">No user details available please click any profile button to view details</p>
          </div>  
        }
      </Card>}
    </div>
  )
}

export default AdminDetailsPage
